<template>
    <div>
        <div class="card mb-3">
            <div class="card-header">
                <a name="investSummary"></a>
                <i class="fa fa-sign-out fa-lg"></i> {{ $t('project.exit.form.title') }}
            
                <div class="float-right" style="margin: 7px 0px 0px 15px;">
                  <a href="#exit" name="exit" v-on:click="expandOrCollapse">
                      <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
                      <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
                  </a>
                </div>
                <div class="float-right">
                    <ul class="nav nav-pills">
                        <li class="nav-item">
                            <a :class="visualization == 1 ? 'nav-link active' : 'nav-link'" href="#exitVisualisation1" name="visualisation1" @click="setVisualisation(1)">Par date</a>
                        </li>
                        <li class="nav-item">
                            <a :class="visualization == 2 ? 'nav-link active' : 'nav-link'" href="#exitVisualisation2" name="exitVisualisation2" @click="setVisualisation(2)">Résumé</a>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="card-body summary" v-if="localVisible">
                
                <div v-if="entites != null && entites.length !== 0">
                  <div v-if="visualization == 1" v-for="(entite,index) in exits" v-bind:data-id="entite.date" :key="entite.date" >
                      
                      <div :class="(index % 2 == 0 ? 'odd' : '') + ' row'">
                          
                          <div class="col-md-3">
                              <label>{{ $t('project.exit.form.person.date') }}:</label>
                              {{ entite.date  | formatDate}}
                          </div>
                          <div class="col-md-6">
                              <label>{{ $t('project.exit.form.person.reason') }}:</label>
                              {{ entite.reason}}
                          </div>
                          
                          <div class="col-md-2">
                              <label for="totalValueInput">{{ $t('project.investment.form.totalValue') }}:</label>
                              {{totalExit(entite) }}
                          </div>

                          <div  class="col-md-1">
                              <div class="float-right">
                                  <a v-if="entite.show == null || !entite.show" href="#exitSummary" @click="expand(index)"><span class="fa fa-expand fa-lg" ></span></a>
                                  <a v-if="entite.show != null && entite.show" href="#exitSummary" @click="compress(index)"><span class="fa fa-compress fa-lg"></span></a>
                              </div>
                          </div>
                      </div>

                      <div class="valueTab" v-if="entite.show != null && entite.show && entite.exitPerson != null" v-for="(value, index2) in entite.exitPerson" :key="value.id">

                          <div :class="(index2 % 2 != 0 ? 'value_odd' : 'value_even') + ' row'">
                              <div class="col-md-9" v-if="value.member != null">
                                  <label>{{ $t('project.exit.form.person.member') }} :</label>
                                  {{ value.member.name }}
                              </div>
                              <div class="col-md-9" v-if="value.partner != null">
                                  <label>{{ $t('project.exit.form.person.partner') }}:</label>
                                  {{ value.partner.name }}
                              </div>
                              
                              <div class="col-md-3">
                                  <label >{{ $t('project.exit.form.person.value') }}:</label>
                                  {{value.value}}
                              </div>

                          </div>

                      </div>

                  </div>

                  <div v-if="visualization == 2">
                    <table class="table table-bordered table-striped" width="100%" cellspacing="0">
                            <thead>
                                <tr>
                                    <th>{{ $t('project.exit.form.person.date')   }}</th>
                                    <th>{{ $t('project.exit.form.person.reason') }}</th>
                                    <th>{{ $t('project.investment.form.totalValueAnges') }}</th>
                                    <th>{{ $t('project.investment.form.totalValueAngesJr') }}</th>
                                    <th>{{ $t('project.investment.form.totalValuePartenaires') }}</th>
                                    <th>{{ $t('project.investment.form.totalValue') }}</th>
                                </tr>
                            </thead>
                            <tfoot>
                                <tr>
                                    <th colspan=2>{{ $t('total') }}</th>
                                    <th>{{ gettotalValueAnges() }}</th>
                                    <th>{{ gettotalValueAngesJr() }}</th>
                                    <th>{{ gettotalValuePartenaires() }}</th>
                                    <th>{{ gettotalValue() }}</th>
                                </tr>
                            </tfoot>
                            <tbody>
                                <tr v-for="entite in resumeData" v-bind:data-id="entite.id" :key="entite.id">
                                    <td>{{ entite.date | formatDate }}</td>
                                    <td>{{ entite.reason }}</td>
                                    <td>{{ entite.amountAngels }}</td>
                                    <td>{{ entite.aqjAmount }}</td>
                                    <td>{{ entite.amountPartners }}</td>
                                    <td>{{ entite.totalValue }}</td>
                                </tr>
                            </tbody>
                        </table>
                  </div>

                </div>

                <div v-if="entites == null || entites.length === 0">
                    {{ $t('form.aucun_donne') }}
                </div>
            
            </div>
        </div>
    </div>
  
</template>

<script>
import {ExittServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'

export default {
  name: 'ExitSummary',
  props: {
    entites: Array,
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localVisible: this.visible,
      exits: [],
      visualization: 1,
      resumeData: [],
    }
  },
  watch: {
    entites: {
      handler: function(newValue, oldVal) {
        this.exits = _(newValue)
          .flatMap(item => {
            return _.map(item.exitPerson, function(person) {
              return person
            })
          })
          .map(m => _.defaults({type: m.partnerId != null ? 1 : m.memberId != null ? 2 : 3}, m))
          .groupBy(x => x.date)
          .map((value, key) => ({
            date: key,
            reason: value[0].reasonText,
            exitPerson: value,
          }))
          .value()
      },
      immediate: true,
    },
  },
  methods: {
    gettotalValueAnges: function() {
      return _.sumBy(this.resumeData, 'amountAngels')
    },
    gettotalValueAngesJr: function() {
      return _.sumBy(this.resumeData, 'aqjAmount')
    },
    gettotalValuePartenaires: function() {
      return _.sumBy(this.resumeData, 'amountPartners')
    },
    gettotalValue: function() {
      return _.sumBy(this.resumeData, 'totalValue')
    },
    setVisualisation: function(visualization) {
      this.visualization = visualization

      if (this.visualization == 2) {
        if (this.resumeData.length == 0) {
          let previewData = _.chain(this.entites[0].exitPerson)
            .groupBy(g => g.date)
            .map((map, key) => ({
              date: key,
              data: _.chain(map)
                .groupBy(grp => grp.reasonText)
                .map((mapG, key) => ({
                  reason: key,
                  amountAngels: _.sumBy(mapG, s => (s.member != undefined && s.memberType !== 3 && s.memberStatus ? s.value : 0)),
                  aqjAmount: _.sumBy(mapG, s => (s.member != undefined && s.memberType === 3 ? s.value : 0)),
                  amountPartners: _.sumBy(
                    mapG,
                    s => (s.partner != undefined || (s.member != undefined && s.memberType !== 3 && !s.memberStatus) ? s.value : 0)
                  ),
                  totalValue: _.sumBy(mapG, 'value'),
                }))
                .value(),
            }))
            .value()

          this.resumeData = _.flatMap(previewData, flat =>
            _.map(flat.data, map => ({
              date: flat.date,
              reason: map.reason,
              amountAngels: map.amountAngels,
              aqjAmount: map.aqjAmount,
              amountPartners: map.amountPartners,
              totalValue: map.totalValue,
            }))
          )
        }
      }
    },
    expandOrCollapse: function() {
      this.localVisible = !this.localVisible
    },
    fetchData: function() {},
    totalExit: function(entite) {
      return _.sumBy(entite.exitPerson, function(x) {
        return parseInt(x.value)
      })
    },
    expand: function(index) {
      this.$set(this.exits[index], 'show', true)
    },
    compress: function(index) {
      this.$set(this.exits[index], 'show', false)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .dataTables_wrapper{
    padding: 0px;
  }

  .summary .row {
    border: 1px solid #e9ecef;
    padding: 15px 0px;
  }
  .summary .row.odd {
    background-color: rgba(0,0,0,.05);
  }

  .summary .row.value_odd {
    background-color: rgba(50,50,50,.3);
  }
  .summary .row.value_even {
    background-color: rgba(50,50,50,.15);
  }

  .summary .row label {
      font-weight: bold;
  }

  .valueTab{
      padding-left: 50px;
  }
  .summary .row label::before {
      content: "| "
  }
</style>




// WEBPACK FOOTER //
// src/components/Investment/ExitSummary.vue